import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootPm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
